import React from "react";
import flut from "../../images/flutter.svg";
import figma from "../../images/figma-logo.svg";
import swift from "../../images/swiftui-logo.svg";
import ui from "../../images/ui-logo.svg";
import acc from "../../images/account.svg";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Card() {
  const navigate = useNavigate()
  return (
    <div>
        <div>
      <div className="wrapper" id="cardwrap">
        <div className=" cr">
          <div className="cr1">
            <div className=" cd cards">
              <div className="cd1 card4">
                <div className=" cd2">
                  <div className="cd3">
                  <p className=" nmpss">Gsuite & Hotmail</p>
                    <p className="cd4">Hotmail</p>
                  </div>
                  <div className="cd5">
                    <div width="60" height="4" opacity="0.3" class="cd6"></div>
                    <div width="90" height="4" opacity="0.3" class="cd7"></div>
                    <div width="80" height="4" opacity="0.3" class="cd8"></div>
                    <div width="120" height="6" opacity="0.4" class="cd9"></div>
                  </div>
                </div>
                <div class="wrapper">
                  <img src={flut} alt="Course logo" class=" cdd" />
                </div>
              </div>
              <div className="cd1 card3">
                <div className=" cd2">
                  <div className="cd3">
                  <p className=" nmpss">Gsuite & Hotmail</p>
                    
                  </div>
                  <div className="cd5">
                    <div width="60" height="4" opacity="0.3" class="cd6"></div>
                    <div width="90" height="4" opacity="0.3" class="cd7"></div>
                    <div width="80" height="4" opacity="0.3" class="cd8"></div>
                    <div width="120" height="6" opacity="0.4" class="cd9"></div>
                  </div>
                </div>
                <div class="wrapper">
                <img alt="" src="	https://cdn-icons-png.flaticon.com/512/4494/4494740.png" className="h-10" />
                </div>
              </div>
              <div className="cd1 card2">
                <div className=" cd2">
                  <div className="cd3">
                  <p className=" nmpss">Private </p>
                    <p className="cd4">Email server</p>
                  </div>
                 <div className="flex justify-center">
                 <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRNB9jvVSEE-s3RNYUvZZ0C9a7Lyyve7ub3NuaKro8&s"  alt="" className="my-2 ml-28 bg-slate-400 opacity-30"/>
                 </div>
                  <div className="cd5">
                    <div width="60" height="4" opacity="0.3" class="cd6"></div>
                    <div width="90" height="4" opacity="0.3" class="cd7"></div>
                    <div width="80" height="4" opacity="0.3" class="cd8"></div>
                    <div width="120" height="6" opacity="0.4" class="cd9"></div>
                  </div>
                </div>
                <div class="wrapper">
                <img src="https://static-00.iconduck.com/assets.00/aws-icon-2048x2048-ptyrjxdo.png" className="h-10 "/>
                </div>
               
              </div>
              <div className="cd1 card1">
                <div className=" cd2">
                  <div className="cd3">
                    <p className=" nmpss">Dedicated Hosting</p>
                  
                  </div>
                  <div className="flex justify-center">
                    <img src="	https://www.upwork.com/catalog-images-resized/568c33b6660a595f28b6555613fe33aa/thumbnail-medium" alt="" className="h-28 my-6 ml-28 bg-slate-400 opacity-30"/ >
                  </div>
                  <div className="cd5">
                    <div width="60" height="4" opacity="0.3" class="cd6"></div>
                    <div width="90" height="4" opacity="0.3" class="cd7"></div>
                    <div width="80" height="4" opacity="0.3" class="cd8"></div>
                    <div width="120" height="6" opacity="0.4" class="cd9"></div>
                  </div>
                </div>
                <div class="wrapper ">
                <img alt="" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbxUVQA2MWL2fX7BvqFj2fulV0Mu8i5VfqwNNhz32e1w&s"  className="h-10 rounded-full "/>
                </div>
              </div>{" "}
            </div>
            <div className="cdd1 text">
              <p className="cdd2"> Hosting
                  </p>
              <h2 className="cdd3">Pro hosting
                  </h2>
            
              <button className="b1" 
               onClick={() =>{localStorage.getItem("token")?(navigate("/profile")):toast("! login require ")}}>
             
                <img alt="" src={acc} className=" b2 icon" />
                <p className="b3" >Read More</p>
              </button>
            
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}
